// isWithinTargetRange.js
const extractNumVal = (value) => {
    if (value === null || value === undefined || isNaN(Number(value))) {
        return null; 
    }
    return Number(value); 
};

const isWithinTargetRange = (value, target) => {
    const cleanedValue = extractNumVal(value);

    // Ensure `target` is an object with valid min/max properties
    if (cleanedValue === null || !target || typeof target !== "object") {
        return false; 
    }
    // console.log('Cleaned Value', cleanedValue);
    const min = target.min !== undefined ? target.min : -Infinity; // Default to -Infinity if min is missing
    const max = target.max !== undefined ? target.max : Infinity;  // Default to Infinity if max is missing

    // Check if the value is within the range
    const isInRange = cleanedValue >= min && cleanedValue <= max;
    // console.log('Range Data', isInRange);
    return isInRange;
};

export default isWithinTargetRange;
